import { render, staticRenderFns } from "./MailsForm.vue?vue&type=template&id=7e69adee"
import script from "./MailsForm.vue?vue&type=script&lang=js"
export * from "./MailsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports